import { render, staticRenderFns } from "./Banka2AvansView.vue?vue&type=template&id=6c21f2c8&"
import script from "./Banka2AvansView.vue?vue&type=script&lang=js&"
export * from "./Banka2AvansView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports